import storesApi from "../../api/stores";
import { latLng } from "leaflet";

const state = () => ({
  queried: [],
  stores: []
});

const getters = {
  byId: state => storeId => state.stores.find(v => v._id === storeId),
  byCity: state => cityId => state.stores.filter(v => v.cityId === cityId)
};

const actions = {
  fetch({ commit, state }, cityId) {
    return new Promise((resolve, reject) => {
      if (state.queried.includes(cityId)) {
        resolve();
      } else {
        storesApi
          .getByCity(cityId)
          .then(stores => {
            commit("addStores", {
              queryId: cityId,
              stores: stores
            });
            resolve();
          })
          .catch(e => reject(e));
      }
    });
  },

  fetchOne({ commit, state }, storeId) {
    return new Promise((resolve, reject) => {
      if (state.queried.includes(storeId)) {
        resolve();
      } else {
        storesApi
          .getOne(storeId)
          .then(store => {
            commit("addStores", {
              queryId: storeId,
              stores: [store]
            });
            resolve();
          })
          .catch(e => reject(e));
      }
    });
  }
};

const mutations = {
  addStores(state, payload) {
    state.queried.push(payload.queryId);

    let newStoreIds = payload.stores.map(v => v._id);
    for (let store of payload.stores) {
      store.location.latLng = latLng(store.location.lat, store.location.lng);
      delete store.location.lat;
      delete store.location.lng;
    }

    state.queried = state.queried
      .filter(v => !newStoreIds.includes(v))
      .concat(newStoreIds);
    state.stores = state.stores
      .filter(v => !newStoreIds.includes(v._id))
      .concat(payload.stores);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
